import {createReducer, on} from "@ngrx/store";
import * as UniverseActions from './planet-resource.actions';
import {PlanetResource} from "../../models/PlanetResource";
export const planetResourceFeatureKey = 'planetResource';
export const planetResourceInitialState: PlanetResource[] = null;
export const planetResourceReducer = createReducer<PlanetResource[] | null>(
  planetResourceInitialState,
  on(UniverseActions.update, (_state, { planetResources }) => planetResources),
);
